import type { AvatarConfig } from './avatar-catalog'
import { hidesAvatarBase } from './avatar-custom'
import { AvatarCustomLayers } from './AvatarCustomLayers'

export function AvatarClothing({
  config: c,
  throwAngle = 0,
}: {
  config: AvatarConfig
  throwAngle?: number
}) {
  const left = c.body === 'slim' ? 70 : c.body === 'broad' ? 43 : 56
  const right = 240 - left
  const shirt = `M${left} 286V229Q${left} 203 93 194H147Q${right} 203 ${right} 229V286Z`
  const hidden = hidesAvatarBase(c, 'clothing')
  return (
    <g>
      {!hidden && c.clothing === 'hero' && (
        <path d="M84 195Q57 202 42 284H198Q183 202 156 195Z" fill={c.clothingColor} />
      )}
      <path
        d={`M${left + 6} 216Q${left - 9} 234 ${left - 11} 268Q${left - 11} 280 ${left} 280Q${left + 10} 281 ${left + 12} 267L${left + 23} 229`}
        fill={c.skin}
        visibility={hidesAvatarBase(c, 'body') ? 'hidden' : undefined}
      />
      <g transform={`rotate(${throwAngle} ${right - 6} 216)`}>
        <path
          d={`M${right - 6} 216Q${right + 9} 234 ${right + 11} 268Q${right + 11} 280 ${right} 280Q${right - 10} 281 ${right - 12} 267L${right - 23} 229`}
          fill={c.skin}
          visibility={hidesAvatarBase(c, 'body') ? 'hidden' : undefined}
        />
        {!hidden && c.clothing === 'plain-long-sleeve' && (
          <path
            d={`M${right - 6} 216Q${right + 9} 234 ${right + 11} 268L${right - 11} 272L${right - 23} 229`}
            fill={c.clothingColor}
          />
        )}
      </g>
      <AvatarCustomLayers config={c} categories={['body']} />
      <g visibility={hidden ? 'hidden' : undefined}>
        {c.clothing === 'plain-long-sleeve' && (
          <path
            d={`M${left + 6} 216Q${left - 9} 234 ${left - 11} 268L${left + 11} 272L${left + 23} 229`}
            fill={c.clothingColor}
          />
        )}
        <path d={shirt} fill={c.clothingColor} />
        <path
          d={`M${left} 238v48h13v-61M${right} 238v48h-13v-61`}
          fill="#13261D"
          opacity=".12"
        />
      </g>
      <path d="M102 181h36v18q-1 18-18 18t-18-18Z" fill={c.skin} />
      <path d="M102 184h36v9q-18 11-36 0Z" fill="#492514" opacity=".14" />
      <g visibility={hidden ? 'hidden' : undefined}>
        {c.clothing === 'plain-vneck' && (
          <path d="M98 196L120 227L142 196Q120 211 98 196Z" fill={c.skin} />
        )}
        {c.clothing === 'tee' && (
          <>
            <path
              d="M96 198q24 31 48 0"
              fill="none"
              stroke="#FFF"
              strokeOpacity=".38"
              strokeWidth="6"
            />
            <path
              d="M120 236q-16-17-20-3t20 27q24-13 20-27t-20 3"
              fill="#FFF"
              opacity=".88"
            />
          </>
        )}
        {(c.clothing === 'polo' || c.clothing === 'shirt') && (
          <>
            <path
              d="M99 193l21 21-15 13-18-24ZM141 193l-21 21 15 13 18-24Z"
              fill="#FFF"
              opacity=".6"
            />
            <path d="M120 215v71" stroke="#FFF" strokeOpacity=".3" strokeWidth="3" />
            {[233, 250, 267].map((y) => (
              <circle key={y} cx="124" cy={y} r="2" fill="#FFF" />
            ))}
            {c.clothing === 'shirt' && (
              <path d="M144 231h23v17q-11 10-23 0Z" fill="#FFF" opacity=".25" />
            )}
          </>
        )}
        {c.clothing === 'hoodie' && (
          <>
            <path
              d="M99 190q-38-1-27 29l26 12 22-16 22 16 26-12q11-30-27-29l-21 22Z"
              fill="#FFF"
              opacity=".23"
            />
            <path
              d="M98 221v23m44-23v23"
              stroke="#FFFAEC"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <path d="M93 259h54l9 27H84Z" fill="#13261D" opacity=".13" />
          </>
        )}
        {c.clothing === 'overalls' && (
          <>
            <path
              d={`M${left} 226Q${left} 201 98 195L101 235h38l3-40Q${right} 201 ${right} 226v60H${left}Z`}
              fill="#FFF8E7"
            />
            <path d="M82 199h12v50h52v-50h12v87H82Z" fill={c.clothingColor} />
            <path d="M88 231h64v55H88Z" fill={c.clothingColor} />
            <path d="M104 248h32v18q-16 10-32 0Z" fill="#FFF" opacity=".25" />
            <g fill="#F7D46B">
              <circle cx="88" cy="234" r="3" />
              <circle cx="152" cy="234" r="3" />
            </g>
          </>
        )}
        {c.clothing === 'dress' && (
          <>
            <path d="M96 194q24 28 48 0l-7 29h-34Z" fill={c.skin} />
            <path d="M83 250h74" stroke="#FFF" strokeOpacity=".5" strokeWidth="6" />
            <path d="M120 250l-13-9v18Zm0 0 13-9v18Z" fill="#FFF4CE" />
            <path
              d="M106 259l-4 27m32-27 4 27"
              stroke="#FFF"
              strokeOpacity=".2"
              strokeWidth="3"
            />
          </>
        )}
        {c.clothing === 'jacket' && (
          <>
            <path d="M103 211h34v75h-34Z" fill="#FFFAED" />
            <path
              d="M94 193l24 40-20 14-13-31Zm52 0-24 40 20 14 13-31Z"
              fill="#FFF"
              opacity=".33"
            />
            <path d="M120 235v51" stroke="#D4DBD1" strokeWidth="3" />
            <path
              d="M70 246h21m58 0h21"
              stroke="#FFF"
              strokeOpacity=".6"
              strokeWidth="3"
            />
          </>
        )}
        {c.clothing === 'hero' && (
          <>
            <path d="M101 196l19 20 19-20 16 14-14 76H99L85 210Z" fill="#FFFAED" />
            <path
              d="m120 226 7 15 16 2-12 11 3 16-14-8-14 8 3-16-12-11 16-2Z"
              fill={c.clothingColor}
            />
            <path d="M97 275h46v11H97Z" fill="#E6BA57" />
          </>
        )}
      </g>
    </g>
  )
}
